<template>
  <ul>
    <li v-if="toDayfeeds.length">
      <FeedBlock :feeds="toDayfeeds" title="Aujourd’hui" />
    </li>
    <li v-if="last7DaysFeeds.length">
      <FeedBlock :feeds="last7DaysFeeds" title="7 derniers jours" />
    </li>
    <li v-if="last30DaysFeeds.length">
      <FeedBlock :feeds="last30DaysFeeds" title="30 derniers jours" />
    </li>
    <li v-if="otherFeeds.length">
      <FeedBlock :feeds="otherFeeds" title="Antérieures" />
    </li>
  </ul>
</template>
<script setup lang="ts">
const { toDayfeeds, last7DaysFeeds, last30DaysFeeds, otherFeeds } =
  useFeedView();
useAppEventView(EventView.Feed);
</script>
<style lang="scss" scoped>
ul {
  display: flex;
  flex-direction: column;
  gap: var(--gap_xl);
}
</style>
